import React from "react";

const PALETTE = [
    "#5624d0", "#a435f0", "#1e88e5", "#00897b",
    "#e64a19", "#c2185b", "#455a64", "#6d4c41",
];

const hashStr = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = (h * 31 + str.charCodeAt(i)) >>> 0;
    }
    return h;
};

const iniciales = (texto) => {
    const palabras = (texto || "").trim().split(/\s+/).filter(Boolean);
    if (palabras.length === 0) return "?";
    if (palabras.length === 1) return palabras[0].slice(0, 2).toUpperCase();
    return (palabras[0][0] + palabras[1][0]).toUpperCase();
};

const CoverPlaceholder = ({ seed, texto }) => {
    const color = PALETTE[hashStr(seed || texto || "x") % PALETTE.length];
    return (
        <div className="cover-placeholder" style={{ background: color }}>
            <span>{iniciales(texto)}</span>
        </div>
    );
};

export default CoverPlaceholder;
